// Copyright (c) Move Closer 2023.

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const VARIANT_SWITCH_COMPONENT_KEY = 'VariantSwitchComponent'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface VariantSwitchConfig {
  switchIcon: string | null
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const VARIANT_SWITCH_CONFIG_MAP: VariantSwitchConfig = {
  switchIcon: null
}
